<script lang="ts" setup>
import { t } from '@/Support/lang'
import { Menu, MenuButton } from '@headlessui/vue'
import {
  PencilSquareIcon,
  ArrowPathIcon,
  Cog8ToothIcon,
  ListBulletIcon,
  ChatBubbleLeftRightIcon,
} from '@heroicons/vue/16/solid'
import MenuItemsDropdowns from '@/Components/App/Global/MenuItemsDropdown.vue'
import MenuItemDropdown from '@/Components/App/Global/MenuItemDropdown.vue'
import { teamPreferences } from '@/Support/Users/userData'
import { update } from '@/Support/Teams/Functions/TeamPreferencesFunctions'
import { usePage } from '@inertiajs/vue3'
import { AiModel, AiModels } from '@/Support/AI/Interfaces/AiModels'

defineProps<{
  currentModel: string
}>()

const emit = defineEmits<{
  (e: 'new'): void
  (e: 'list'): void
  (e: 'view-chat'): void
  (e: 'reload'): void
  (e: 'model-updated', value: AiModel): void
}>()

const aiModels = usePage().props.aiModels as AiModels

const updateModel = async (model: AiModel) => {
  const preferences = teamPreferences.value
  preferences.aiModel = model.value
  await update({ preferences })
  emit('model-updated', model)
}
</script>
<template>
  <Menu v-slot="{ open }" as="div" class="inline-block text-left">
    <div>
      <MenuButton
        class="flex items-center text-neutral-400 hover:text-neutral-600 focus:outline-hidden"
      >
        <span class="sr-only">{{ t(open ? 'Close menu' : 'Open menu') }}</span>
        <Cog8ToothIcon class="h-5 w-5" aria-hidden="true" />
      </MenuButton>
    </div>

    <MenuItemsDropdowns class="left-0 origin-bottom-left bottom-10">
      <div class="py-1 normal-case font-normal">
        <MenuItemDropdown
          :icon="PencilSquareIcon"
          title="ai.query.menu.new"
          @clicked="emit('new')"
        />
        <MenuItemDropdown
          :icon="ListBulletIcon"
          title="ai.query.menu.load-list"
          @clicked="emit('list')"
        />
        <MenuItemDropdown
          :icon="ChatBubbleLeftRightIcon"
          title="ai.query.menu.view-chat"
          @clicked="emit('view-chat')"
        />
      </div>
      <div class="py-1">
        <MenuItemDropdown
          :icon="ArrowPathIcon"
          title="ai.query.menu.reload"
          @clicked="emit('reload')"
        />
      </div>
      <div class="py-1">
        <MenuItemDropdown
          v-for="model in aiModels"
          v-tooltip="model.description"
          :app-icon="model.icon"
          :icon-active="currentModel === model.value"
          :title="model.name"
          @clicked="updateModel(model)"
        />
      </div>
    </MenuItemsDropdowns>
  </Menu>
</template>
